import { Button } from '@core/ui';
import { EditProfileFormSaveButtonProps } from './types';

export const EditProfileFormSaveButton = ({ children, classNames, ...props }: EditProfileFormSaveButtonProps) => {
    return (
        <Button variant="primary" classNames={`${classNames}`} {...props}>
            {children}
        </Button>
    );
};
